import { render, staticRenderFns } from "./oohSetting.vue?vue&type=template&id=5d0dbe34&scoped=true&"
import script from "./oohSetting.vue?vue&type=script&lang=tsx&"
export * from "./oohSetting.vue?vue&type=script&lang=tsx&"
import style0 from "./oohSetting.vue?vue&type=style&index=0&id=5d0dbe34&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d0dbe34",
  null
  
)

export default component.exports